import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { _HttpClient } from '@delon/theme';
import { AccountCodeComponent } from 'src/app/components/modal/account-code/account-code-modal.component';

import { SelectInstantBaseComponent } from '../../selectInstant-base';

@Component({
  selector: 'app-jv-acc-select',
  templateUrl: './jv-acc-select.component.html',
  styleUrls: ['./jv-acc-select.component.less'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => JvAccountSelectComponent),
      multi: true
    }
  ]
})
export class JvAccountSelectComponent
  extends SelectInstantBaseComponent
  implements OnInit
{
  @ViewChild('codeModal', { static: true })
  accCodeModalComponent!: AccountCodeComponent;

  NotShowInReport: boolean = false;

  constructor(
    http: _HttpClient,
    cdr: ChangeDetectorRef,
    router: Router,
    private resueTabService: ReuseTabService
  ) {
    super(http, cdr, router);
    this.valueField = 'id';
  }

  ngOnInit(): void {
    this.checkAddNewOptionInReportAccess();
  }

  getUrl(searchValue: string): string {
    let url = `api/journals/accountcodes?$count=false&$top=50&$skip=0`;
    if (searchValue && searchValue.trim()) {
      url = `${url}&keyword=${encodeURIComponent(searchValue.trim())}`;
    } else {
      url = `${url}&$orderby=code asc`;
    }
    return url;
  }

  @Input() labelField: 'code' | 'name' | null = null;

  getLabel(item: any) {
    if (item) {
      if (this.labelField === 'code') return item.code;
      else if (this.labelField === 'name') return item.name;
      return `${item.code} - ${item.name}`;
    }
  }

  // set the location want to navigate
  jump(): string {
    return '/gl/coa';
  }

  // set the param
  queryParam(): String {
    return 'AccountCode';
  }

  onSubmit(account: any) {
    this.selected = account;
    // TO-DO: assign the created account as current selected value
  }

  override valueChanged(val: any): void {
    if (val === 'addNew') {
      this.addNew();
      //this.instantData = '';
    } else {
      super.valueChanged(val);
    }
  }

  override addNew() {
    super.addNew();
    this.accCodeModalComponent.new({
      parentId: '',
      isActive: true,
      name: this.instantData
    });

    setTimeout(() => {
      this.clearSelection();
    }, 50);
  }

  checkAddNewOptionInReportAccess(): boolean {
    let curUrl = this.resueTabService.curUrl.toLowerCase();

    if (curUrl.includes('report')) {
      this.NotShowInReport = true;
    } else {
      this.NotShowInReport = false;
    }

    return this.NotShowInReport;
  }

  focus() {
    if (this.selector) {
      this.selector.focus();
    }
  }
}
